import React, { useState, useEffect, useRef } from "react";

const CrossTab = (value) => {
  const [radioState, setRadioState] = useState("col");
  const [rowSelectedQIndex, setRowSelectedQIndex] = useState(1);
  const [colSelectedQIndex, setColSelectedQIndex] = useState(1);

  useEffect(() => {
    const radio_state = JSON.parse(localStorage.getItem("crosRadioInfo"));
    if (radio_state) setRadioState(radio_state);

    const row_SelectedQIndex = JSON.parse(
      localStorage.getItem("rowSelectedQIndex")
    );
    if (radio_state) setRowSelectedQIndex(row_SelectedQIndex);

    const col_SelectedQIndex = JSON.parse(
      localStorage.getItem("colSelectedQIndex")
    );
    if (radio_state) setColSelectedQIndex(col_SelectedQIndex);
  }, []);

  const changeRadioState = (value) => {
    localStorage.setItem("crosRadioInfo", JSON.stringify(value));
    setRadioState(value);
  };

  const tableData = () => {
    var tableDatas = value.data.main_db.crosstabs.find(
      (e) =>
        Number(e.question_column.number) === Number(colSelectedQIndex) &&
        Number(e.question_row.number) === Number(rowSelectedQIndex)
    );
    return tableDatas;
  };

  const transposedTableData = () => {
    var transposedDatas = value.data.main_db.crosstabs.find(
      (e) =>
        Number(e.question_column.number) === Number(rowSelectedQIndex) &&
        Number(e.question_row.number) === Number(colSelectedQIndex)
    );
    return transposedDatas;
  };

  const QueryState = (index) => {
    if (index) {
      if (value.data.main_db.questions[index - 1].is_closed) {
        return "Closed-End";
      }

      if (value.data.main_db.questions[index - 1].is_multi) {
        return "Multi-End";
      }

      if (value.data.main_db.questions[index - 1].is_open) {
        return "Open-End";
      }
    }
  };

  const divRef = useRef();

  const [overFlage, setOverFlage] = useState(false);
  const [screenFullWidth, setScreenFullWidth] = useState();

  const getScreenDimensions = () => {
    const fullScrenWidth = window.innerWidth;
    setScreenFullWidth(fullScrenWidth);
    const newWidth = divRef.current.clientWidth;

    if (fullScrenWidth < newWidth) {
      setOverFlage(true);
    } else {
      setOverFlage(false);
    }
  };

  useEffect(() => {
    getScreenDimensions();
  }, [colSelectedQIndex]);

  useEffect(() => {
    getScreenDimensions();
  }, [rowSelectedQIndex]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.addEventListener("resize", getScreenDimensions);
    }, 0);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", getScreenDimensions);
    };
  });

  return (
    <div>
      <div className="container">
        <div>
          <div className="d-flex justify-content-center">
            <div className="cross-detail-container">
              <div className="cross-detail">
                <div className="cross-detail-content">
                  <strong style={{ fontSize: "16px" }}>
                    Cross Table Elaboration
                  </strong>
                  <div>@LogRatio report ID: {value.data.arguments.log_id}</div>
                  <div className="mt-3">
                    <strong>Find this table in:</strong>
                  </div>
                  <div>File: {value.data.arguments.log_id}.xlsx</div>
                  <div>
                    Sheet: CrossTab - {QueryState(colSelectedQIndex)} - Q
                    {colSelectedQIndex}
                  </div>
                  <div className="mt-4">
                    <a
                      className="help-link"
                      href="#!"
                      onClick={
                        () => window.parent.postMessage({
                          cmd: "hyperlink",
                          url: "https://logratio.com/users-guide/#section-cross-tables"
                        }, "https://logratio.com")
                      }
                    >
                      Help with this analysis
                    </a>
                  </div>
                </div>
              </div>

              <div className="cross-option_container">
                <div className="cross-option_content">
                  <div className="d-flex justify-content-between m-1 mb-4 mr-5">
                    <div style={{ fontSize: "16px" }}>
                      <strong>Select 2 questions:</strong>
                    </div>
                  </div>

                  <div
                    className="d-flex align-center"
                    style={{ margin: "10px" }}
                  >
                    <div className="label">Rows:</div>
                    <select
                      className="form-control"
                      style={{ fontSize: "16px" }}
                      value={colSelectedQIndex}
                      onChange={(e) => {
                        localStorage.setItem(
                          "colSelectedQIndex",
                          JSON.stringify(e.target.value)
                        );
                        setColSelectedQIndex(e.target.value);
                      }}
                    >
                      {value.data.main_db.questions.map((item, index) => (
                        <option key={index} value={item.number}>
                          {item.desc}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    className="d-flex align-center"
                    style={{ margin: "10px" }}
                  >
                    <div className="label">Cols:</div>
                    <select
                      className="form-control"
                      style={{ fontSize: "16px" }}
                      value={rowSelectedQIndex}
                      onChange={(e) => {
                        localStorage.setItem(
                          "rowSelectedQIndex",
                          JSON.stringify(e.target.value)
                        );
                        setRowSelectedQIndex(e.target.value);
                      }}
                    >
                      {value.data.main_db.questions.map((item, index) => (
                        <option key={index} value={item.number}>
                          {item.desc}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    className="d-flex"
                    style={{ margin: "10px 10px 0px 10px" }}
                  >
                    <div className="label">Show: </div>
                    <div className="col-5">
                      <label className="d-flex justify-content-center">
                        <input
                          type="radio"
                          onChange={(e) => changeRadioState("col")}
                          checked={radioState === "col"}
                        />
                        <div className="ml-1">Column %'s</div>
                      </label>
                    </div>
                    <div className="col-5">
                      <label className="d-flex justify-content-center">
                        <input
                          type="radio"
                          onChange={(e) => changeRadioState("row")}
                          checked={radioState === "row"}
                        />
                        <div className="ml-1">Row %'s</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              className="d-flex mt-3"
              style={
                overFlage
                  ? {
                    width: screenFullWidth - 50,
                    overflowX: "scroll",
                    overflowY: "hidden",
                    justifyContent: "start",
                  }
                  : {
                    overflowX: "hidden",
                    overflowY: "hidden",
                    justifyContent: "center",
                  }
              }
            >
              <div ref={divRef} className="d-flex">
                {radioState === "col" || radioState === "both" ? (
                  <div
                    className={
                      radioState === "both" ? "cross-table-content" : null
                    }
                  >
                    <strong>
                      {" "}
                      Column Total, [{QueryState(colSelectedQIndex)}]
                    </strong>
                    <table className="cross-table">
                      <thead>
                        <tr className="table_border_th">
                          <th rowSpan="3">
                            {transposedTableData().question_row.desc}
                          </th>
                          <th
                            colSpan={
                              Object.keys(
                                transposedTableData().question_column.answers
                              ).length
                            }
                          >
                            {transposedTableData().question_column.desc}
                          </th>
                          <th rowSpan="2"></th>
                        </tr>
                        <tr className="table_border_th">
                          {transposedTableData().question_column.answers.map(
                            (items, index) => (
                              <th key={index}>(c{index + 1})</th>
                            )
                          )}
                        </tr>
                        <tr className="table_border_th">
                          {transposedTableData().question_column.answers.map(
                            (items, index) => (
                              <th key={index}> {items.desc} </th>
                            )
                          )}
                          <th>Sum</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transposedTableData().question_row.answers.map(
                          (items, index) => (
                            <tr key={index} className="table_border_th">
                              <th key={index}>
                                <div>
                                  <div> {items.desc} </div>
                                  <div>% (r{index + 1})</div>
                                  <div>Signif</div>
                                </div>
                              </th>

                              {transposedTableData().answer_dataset.map(
                                (data_items, data_index) => (
                                  <td
                                    key={data_index}
                                    style={
                                      Object.keys(
                                        transposedTableData().question_column
                                          .answers
                                      ).length -
                                        1 ===
                                        data_index
                                        ? { borderRight: "solid 1px" }
                                        : null
                                    }
                                  >
                                    <div>
                                      <div>{data_items[index]}</div>
                                      <div>
                                        {Number(
                                          transposedTableData().row_percents[
                                          data_index
                                          ][index] * 100
                                        ).toFixed(1)}
                                        %
                                      </div>
                                      <div>
                                        {
                                          transposedTableData()
                                            .class_signifs_array[index][
                                          data_index
                                          ]
                                        }
                                      </div>
                                    </div>
                                  </td>
                                )
                              )}

                              <td className="cross-table_td">
                                <div>
                                  <div>
                                    {transposedTableData().row_totals[index]}
                                  </div>
                                  <div>
                                    {Number(
                                      transposedTableData().row_total_percents[
                                      index
                                      ] * 100
                                    ).toFixed(1)}
                                    %
                                  </div>
                                  <div>
                                    {
                                      transposedTableData().sum_signifs_array[
                                      index
                                      ]
                                    }
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                      <tfoot>
                        <tr className="table_border_th">
                          <th>
                            <div className="cross-table-th-width">Sum</div>
                            <div>%</div>
                            <div>Signif</div>
                          </th>
                          {transposedTableData().column_totals.map(
                            (item, index) => (
                              <td
                                key={index}
                                style={
                                  Object.keys(
                                    transposedTableData().column_totals
                                  ).length -
                                    1 ===
                                    index
                                    ? { borderRight: "solid 1px" }
                                    : null
                                }
                              >
                                <div>
                                  <div>{item}</div>
                                  <div>100%</div>
                                  <div></div>
                                </div>
                              </td>
                            )
                          )}
                          <th>
                            <div>
                              <div>
                                {transposedTableData().row_totals.reduce(
                                  function (a, b) {
                                    return a + b;
                                  }
                                )}
                              </div>
                              <div>100%</div>
                              <div></div>
                            </div>
                          </th>
                        </tr>
                        <tr className="table_border_th">
                          <th className="pt-1 pb-1">
                            Error <div>(x +/- %)</div>
                          </th>
                          {transposedTableData().column_errors.map(
                            (item, index) => (
                              <th>{Number(item * 100).toFixed(1)}%</th>
                            )
                          )}
                          <th>
                            {Number(
                              transposedTableData().total_error * 100
                            ).toFixed(1)}
                            %
                          </th>
                        </tr>
                      </tfoot>
                    </table>

                    <div className="mt-4">
                      <div>
                        Chi^2 - Ho: col's & rows dep't:{" "}
                        {transposedTableData().chi_is_associated === true
                          ? " TRUE "
                          : " FALSE "}
                        ( chi^2 ={" "}
                        {Number(transposedTableData().chi_squared).toFixed(4)},
                        p = {Number(transposedTableData().p_value).toFixed(4)} )
                      </div>
                      <div>
                        Eta = {Number(transposedTableData().eta).toFixed(4)},
                        Eta^2 ={" "}
                        {Number(transposedTableData().eta ** 2).toFixed(4)}
                      </div>
                      <div>
                        SpearmanRho: sR ={" "}
                        {Number(transposedTableData().spearman_rho).toFixed(4)},
                        sR^2 ={" "}
                        {Number(
                          transposedTableData().spearman_rho ** 2
                        ).toFixed(4)}
                      </div>
                    </div>
                  </div>
                ) : null}

                {radioState === "row" || radioState === "both" ? (
                  <div
                    className={
                      radioState === "both" ? "cross-table-content" : null
                    }
                  >
                    <strong>
                      {" "}
                      Row Total, [{QueryState(rowSelectedQIndex)}]{" "}
                    </strong>
                    <table className="cross-table">
                      <thead>
                        <tr className="table_border_th">
                          <th rowSpan="3">
                            {tableData().question_column.desc}
                          </th>
                          <th
                            colSpan={
                              Object.keys(tableData().question_row.answers)
                                .length
                            }
                          >
                            {tableData().question_row.desc}
                          </th>
                          <th rowSpan="2" colSpan="2"></th>
                        </tr>
                        <tr className="table_border_th">
                          {tableData().question_row.answers.map(
                            (items, index) => (
                              <th key={index}>(c{index + 1})</th>
                            )
                          )}
                        </tr>
                        <tr className="table_border_th">
                          {tableData().question_row.answers.map(
                            (items, index) => (
                              <th key={index}> {items.desc} </th>
                            )
                          )}
                          <th>Sum</th>
                          <th>
                            Error <div style={{ width: "50px" }}>(x +/- %)</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData().question_column.answers.map(
                          (items, index) => (
                            <tr key={index} className="table_border_th">
                              <th key={index}>
                                <div className="cross-table-th-width">
                                  {" "}
                                  {items.desc}{" "}
                                </div>
                                <div>% (r{index + 1})</div>
                                <div>Signif</div>
                              </th>
                              {tableData().answer_dataset[index].map(
                                (data_items, data_index) => (
                                  <td
                                    key={data_index}
                                    style={
                                      Object.keys(
                                        tableData().answer_dataset[index]
                                      ).length -
                                        1 ===
                                        data_index
                                        ? { borderRight: "solid 1px" }
                                        : null
                                    }
                                  >
                                    <div>
                                      <div>{data_items}</div>
                                      <div>
                                        {Number(
                                          tableData().column_percents[index][
                                          data_index
                                          ] * 100
                                        ).toFixed(1)}
                                        %
                                      </div>
                                      <div>
                                        {tableData().class_signifs_array[
                                          data_index
                                        ][index].replace(/r/g, "c")}
                                      </div>
                                    </div>
                                  </td>
                                )
                              )}
                              <td className="cross-table_td">
                                <div>
                                  <div>{tableData().column_totals[index]}</div>
                                  <div>100%</div>
                                  <div></div>
                                </div>
                              </td>
                              <td className="cross-table_td">
                                <div>
                                  <div style={{ height: "16px" }}></div>
                                  <div style={{ border: "0px" }}>
                                    {Number(
                                      tableData().column_errors[index] * 100
                                    ).toFixed(1)}
                                    %
                                  </div>
                                  <div style={{ height: "14px" }}></div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                      <tfoot>
                        <tr className="table_border_th">
                          <th>
                            <div className="cross-table-th-width">Sum</div>
                            <div>%</div>
                            <div>Signif</div>
                          </th>
                          {tableData().row_totals.map((item, index) => (
                            <td
                              key={index}
                              style={
                                Object.keys(tableData().row_totals).length -
                                  1 ===
                                  index
                                  ? { borderRight: "solid 1px" }
                                  : null
                              }
                            >
                              <div>
                                <div>{item}</div>
                                <div>
                                  {Number(
                                    tableData().row_total_percents[index] * 100
                                  ).toFixed(1)}
                                  %
                                </div>
                                <div>
                                  {tableData().sum_signifs_array[index].replace(
                                    /r/g,
                                    "c"
                                  )}
                                </div>
                              </div>
                            </td>
                          ))}
                          <td className="cross-table_td">
                            <div>
                              <div>
                                {tableData().row_totals.reduce(function (a, b) {
                                  return a + b;
                                })}
                              </div>
                              <div>100%</div>
                              <div></div>
                            </div>
                          </td>
                          <td className="cross-table_td">
                            {Number(tableData().total_error * 100).toFixed(1)}%
                          </td>
                        </tr>
                      </tfoot>
                    </table>

                    <div className="mt-4">
                      <div>
                        Chi^2 - Ho: col's & rows dep't:{" "}
                        {tableData().chi_is_associated === true
                          ? " TRUE "
                          : " FALSE "}
                        ( chi^2 = {Number(tableData().chi_squared).toFixed(4)},
                        p = {Number(tableData().p_value).toFixed(4)} )
                      </div>
                      <div>
                        Eta = {Number(tableData().eta).toFixed(4)}, Eta^2 ={" "}
                        {Number(tableData().eta ** 2).toFixed(4)}
                      </div>
                      <div>
                        SpearmanRho: sR ={" "}
                        {Number(tableData().spearman_rho).toFixed(4)}, sR^2 ={" "}
                        {Number(tableData().spearman_rho ** 2).toFixed(4)}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrossTab;
